module.exports = __webpack_public_path__ + "static/media/dinner.b1fd9576.svg";